import * as Sentry from "@sentry/browser";

export const trackError = error => {
  Sentry.captureException(error);
};

export const captureMessage = message => {
  Sentry.captureMessage(message);
}
